/**
=========================================================
* Argon Dashboard 2 PRO MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-mui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useState } from "react";

// Argon Dashboard 2 PRO MUI components
import TemplateSequenceSelector from "0.Mine/0.Components/CRM/Sequence/Templater";
import ArgonBox from "components/ArgonBox";

// Argon Dashboard 2 PRO MUI example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

function WorkflowSelector() {
  return (
    <DashboardLayout>
      <ArgonBox py={12}>
        <ArgonBox mb={12}>
          <TemplateSequenceSelector />
        </ArgonBox>
      </ArgonBox>
      <Footer />
    </DashboardLayout>
  );
}

export default WorkflowSelector;
